import {Component} from '@angular/core';
import {TranslateService} from "@ngx-translate/core";
import {Language} from "../../../models/language";
import {Router} from "@angular/router";

@Component({
  selector: 'app-premium-physical-cards',
  templateUrl: './premium-physical-cards.component.html',
  styleUrls: ['./premium-physical-cards.component.scss', 'premium-physical-cards-media.component.scss']
})
export class PremiumPhysicalCardsComponent {

  currentLang: string = '';

  constructor(private router: Router,
              public translate: TranslateService) {
    this.currentLang = this.translate.currentLang || Language.HY;
    this.translate.onLangChange.subscribe((event) => {
      this.currentLang = event.lang;
    });
  }

  orderNow() {
    this.router.navigate(['/products']);
  }

  protected readonly Language = Language;
}
